import { useTranslation } from 'react-i18next'

import { ReportTableModal } from '../../../../../ReportTableModal'

import { POST_REPORTS_VIEWS_TAB } from './NewsboardPostReportsTableModal.constants'
import { getReportTabsConfig } from './NewsboardPostReportsTableModal.utils'

function NewsboardPostReportsTableModal({
  entityId,
  headerProps,
  initialTab = POST_REPORTS_VIEWS_TAB,
  onClose,
}) {
  const { t } = useTranslation()

  const tabs = getReportTabsConfig(t)

  return (
    <ReportTableModal
      entityId={entityId}
      headerTextKey={headerProps?.text || 'Modal.ReportsModalTitleKey'}
      initialTab={initialTab}
      tabs={tabs}
      onClose={onClose}
    />
  )
}

export default NewsboardPostReportsTableModal
